import { trimStart } from 'lodash';

import { SharedChipProps } from '~/eds/src/types/SharedChipProps';

export const fileTypesToChips = (
  fileTypes?: string[] | null,
): SharedChipProps[] =>
  (fileTypes || []).map((fileType) => ({
    text: trimStart(fileType, '.'),
  }));
